"use client"

import React from 'react';
import {observer} from "mobx-react";
import {FilesFoldersListAndPreview} from "../blocks/TerracedGridTheme/FilesFoldersBlock/FilesFoldersBlock";
import {ISchoolFeedUrlQueries} from "../../utils/SchoolBlocksUtilities";
import {useSchoolFeedInfiniteScroll} from "./hooks/useSchoolFeedInfiniteScroll";
import {InitialLoadingIndicatorWrapper} from "./InitialLoadingIndicatorWrapper";
import {IReactiveFileContentItem, IReactiveFolderContentItem} from "../../stores/SchoolFeedStore";
import {useStores} from "../../stores/useStores";

const SchoolFeedFilesDisplay: React.FC<{
    urlQuery: ISchoolFeedUrlQueries,
}> = observer((props) => {
    const {schoolFeedStore} = useStores();

    const {contentItems, showViewMore, isLoading, size, setSize, mutate, error} = useSchoolFeedInfiniteScroll(
        "files",
        props.urlQuery.following || "",
        props.urlQuery.orgId || "",
        {
            is_file: true,
            is_folder: true,
        }
    )

    async function handleDeleteContentItem(contentItem) {
        await schoolFeedStore.deleteItem(contentItem, contentItem.organization_id);
        await mutate();
    }

    return <InitialLoadingIndicatorWrapper
        initialFetchIsLoading={contentItems.length === 0 && isLoading}
        dataSize={contentItems.length}
        errorCode={error?.status}
        showInitialLoadingIndicator={true}
    >
        <div>
            <FilesFoldersListAndPreview
                useInfiniteScroll={process.env.NEXT_PUBLIC_APP_CTX === "schoolfeed"}
                handleFetchMore={() => setSize(size+1)}
                shouldFetchMore={showViewMore}
                filesAndFolders={(contentItems as unknown) as Array<IReactiveFileContentItem & IReactiveFolderContentItem>}
                expandedView={false}
                handleDelete={handleDeleteContentItem}
                editing={false}
                blockObj={{} as IFilesTerraceBlock}
                aboveTheFold={true}
            />
        </div>
    </InitialLoadingIndicatorWrapper>
})

export default SchoolFeedFilesDisplay;
